const mentionRegex = /\[~(accountid:)?(.*?)?\]/gm;
const codeRegex = /{code:?(.*?)}(?:.*){code}/gm;
const fileRegex = /\[\^(.*?)\]/gm;
const newlineRegex = /(\r\n|\r|\n)/gm;
const linkRegex = /\[(.*?)?\|(.*?)\]/gm;
const imageRegex = /!(.*?)?\|(?:.*?)!/gm;
const quoteRegex = /{quote}(.*?){quote}/gm;
const colorRegex = /{color:(.*?)}(.*?){color}/gm;
const boldRegex = /\*(.*?)\*/gm;

export default {
    methods: {
        replaceNewline(value) {
            value = value.replace(newlineRegex,'<br />');
            return value.replace('<br /><br /><br /><br />','<br /><br />'); // 4 is a bit much in this view.
        },
        parseString(stringValue) {
            const vm = this;
            stringValue = stringValue || '';

            const parseRegex = (regex, value, callback) => {
                let match = regex.exec(value);
            
                if(match) {
                    do{
                        callback(match);
                        match = regex.exec(value);
                    } while(match);
                }
            
                return value;
            };

            const replaceMentions = (value) => {
                parseRegex(mentionRegex, value, (match) => {
                    let user;

                    if (!match[1]) { //Identifier is user name
                        user = vm.users.find(user => user.name === match[2]);
                    } else { //Identifier is accountId
                        user = vm.users.find(user => user.accountId === match[2]);
                    }

                    if(user) {
                        value = value.replace(
                            match[0], `<span ${vm.$options._scopeId} class="mention">${user.displayName}</span>`
                        );
                    }
                });

                return value;
            };
            
            const replaceCode = (value) => {
                parseRegex(codeRegex, value, (match) => {
                    const type = match[1] ? ` (${match[1]})` : '';
                        
                    const replacement =   
                        `<span ${vm.$options._scopeId} class="code-snippet">
                            <i class="fa fa-code" style="font-weight:bold;"></i> code snippet${type}
                        </span>`;
        
                    value = value.replace(match[0], replacement);
                });

                return value;
            };
            
            const replaceFiles = (value) => {
                parseRegex(fileRegex, value, (match) => {
                    const name = match[1] || '';
                    const file = vm.attachments.find((file) => file.filename === name);

                    const replacement =
                        `<span ${vm.$options._scopeId} class="file-shared">
                            <a ${vm.$options._scopeId} href="${file.content}">
                                <i class="far fa-file-alt" style="font-weight:bold;"></i> file: ${name}
                            </a>
                        </span>`;
            
                    value = value.replace(match[0], replacement);
                });

                return value;
            };
            
            const replaceLinks = (value) => {
                parseRegex(linkRegex, value, (match) => {
                    const text = match[1];
                    const url = match[2];
                    
                    let replacement = `<a href="${url}">${text}</a>`;
                    value = value.replace(match[0], replacement);
                });

                return value;
            };

            const replaceImages = (value) => {
                parseRegex(imageRegex, value, (match) => {
                    const name = match[1];
                    const image = vm.attachments.find((file) => file.filename === name);
                    const replacement = `<img ${vm.$options._scopeId} src="${image.thumbnail}">`;

                    value = value.replace(match[0], replacement);
                });

                return value;
            };

            const replaceQuotes = (value) => {
                parseRegex(quoteRegex, value, (match) => {
                    const quote = match[1];
                    const replacement = `<span ${vm.$options._scopeId} class="quote">${quote}</span>`;
                    value = value.replace(match[0], replacement);
                });

                return value;
            };

            const replaceColor = (value) => {
                parseRegex(colorRegex, value, (match) => {
                    const color = match[1];
                    const text = match[2];

                    const replacement = `<span style="color:${color}">${text}</span>`;
                    value = value.replace(match[0], replacement);
                });

                return value;
            };

            const replaceBold = (value) => {
                parseRegex(boldRegex, value, (match) => {
                    const text = match[1];
                    const replacement = `<span style="font-weight:bold">${text}</span>`;
                    value = value.replace(match[0], replacement);
                });

                return value;
            };

            stringValue = vm.replaceNewline(stringValue);
            stringValue = replaceMentions(stringValue);
            stringValue = replaceCode(stringValue);
            stringValue = replaceFiles(stringValue);
            stringValue = replaceLinks(stringValue);
            stringValue = replaceImages(stringValue);
            stringValue = replaceQuotes(stringValue);
            stringValue = replaceColor(stringValue);
            stringValue = replaceBold(stringValue);

            return stringValue;
        }
    }
};